module.exports = __webpack_public_path__ + "img/logo.7962f89f.png";